export const DataSourcesFileSeparatorList = [
  { label: ', (comma)', id: 'comma' },
  { label: '; (semicolon)', id: 'semicolon' },
  { label: ': (colon)', id: 'colon' },
  { label: 'space', id: 'space' },
  { label: 'tab', id: 'tab' },
  { label: '', id: 'custom' },
];
